import {
  getBaseUrl,
  getImageBaseUrl,
  getImageInventoryBaseUrl,
  getSchemaName,
  isLiveMode,
} from "../common/common-methods";

export const baseServerAdress = isLiveMode()
  ? {
    IMAGE: `https://${getImageBaseUrl()}/`,
    IMAGE_INVENTORY: `https://${getImageInventoryBaseUrl()}/images/ecom1122/items/compress/thumbnails/`,
    API: `https://${getBaseUrl()}/api/v1`,
    REPORTS: `https://${getBaseUrl()}/`,
    EPROOF: `https://${getImageBaseUrl()}/proofs/${getSchemaName()}/`,
    MANUAL_EPROOF: `https://${getImageBaseUrl()}/attachments/${getSchemaName()}/`,
    TRACKING_REPORT: `https://${getImageBaseUrl()}/reports/export/${getSchemaName()}/`,
    RESALE_CERTIFICATE: `https://${getBaseUrl()}/resale_certificates/${getSchemaName()}/`,
  }
  : {
    IMAGE: `https://${getImageBaseUrl()}/`,
    IMAGE_INVENTORY: `https://${getImageInventoryBaseUrl()}images/ecomtest/items/compress/thumbnails/`,
    API: `https://${getBaseUrl()}/api/v1`,
    REPORTS: `https://${getBaseUrl()}/`,
    EPROOF: `https://${getImageBaseUrl()}/proofs/${getSchemaName()}/`,
    MANUAL_EPROOF: `https://${getImageBaseUrl()}/attachments/${getSchemaName()}/`,
    TRACKING_REPORT: `https://${getImageBaseUrl()}/reports/export/${getSchemaName()}/`,
    RESALE_CERTIFICATE: `https://${getBaseUrl()}/resale_certificates/${getSchemaName()}/`,
  };
